import { render, staticRenderFns } from "./HealthCoverageDate.vue?vue&type=template&id=723959fe&scoped=true"
import script from "./HealthCoverageDate.vue?vue&type=script&lang=js"
export * from "./HealthCoverageDate.vue?vue&type=script&lang=js"
import style0 from "./HealthCoverageDate.vue?vue&type=style&index=0&id=723959fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723959fe",
  null
  
)

export default component.exports